export default __webpack_public_path__ + "static/media/graph-line.55617302.svg";